export default __webpack_public_path__ + "static/media/loading_black.f8da1532.gif";